import React from 'react';
import classNames from 'classnames';

import s from './styles.module.scss';

import type { IBaseComponentProps } from 'infrastructure/interfaces';

interface IProps extends IBaseComponentProps {
  padding?: string;
}

const BaseWrapper: React.FC<IProps> = (props) => {
  const { className, children, padding = '32px' } = props;
  const wrapperClassNames = classNames(s.wrapper, className);
  return (
    <div className={wrapperClassNames} style={{ padding }}>
      {children}
    </div>
  );
};

export default BaseWrapper;
